import { t } from 'i18next';
import * as yup from 'yup';

import { PartNoteType } from './enums';

export const addPartNoteSchema = (types: PartNoteType[] | string[]) =>
  yup.object().shape({
    notes: yup
      .object()
      .shape(
        (types as string[]).reduce(
          (acc, type) => ({
            ...acc,
            [type]: yup.object().shape({
              enabled: yup.boolean().nullable().required(),
              content: yup
                .string()
                .label(t('labelNote'))
                .nullable()
                .when('enabled', {
                  is: true,
                  then: yup.string().label(t('labelNote')).nullable().required(),
                }),
            }),
          }),
          {}
        )
      )
      .test('atLeastOneEnabled', t('errorNoteRequired'), (value) => {
        return Object.values(value).some((note: { enabled: boolean }) => note.enabled);
      }),
  });
